"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var _FormState = _interopRequireDefault(require("MeetingsLib/models/FormState"));

var _handleActions;

var initialState = new _FormState.default();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  var _action$payload = action.payload,
      formPrefills = _action$payload.bookInfo.formPrefills,
      configuredCustomFormFields = _action$payload.customFormFields;
  state = state || new _FormState.default(); // merge fields from query params with fields saved on link
  // don't filter out fields that are not saved on link
  // support "hidden field" submissions SMMC-1144

  var _state$toObject = state.toObject(),
      customFormFields = _state$toObject.customFormFields,
      defaultFormFields = (0, _objectWithoutProperties2.default)(_state$toObject, ["customFormFields"]);

  defaultFormFields = (0, _immutable.Map)(defaultFormFields).map(function (field, key) {
    return field || formPrefills.get(key);
  });
  customFormFields = configuredCustomFormFields.map(function (field, key) {
    return formPrefills.getIn(['customFormFields', key], field);
  }).merge(state.customFormFields);
  return state.merge(defaultFormFields).set('customFormFields', customFormFields).set('originalFormState', state.delete('originalFormState'));
}), (0, _defineProperty2.default)(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED, function (state, action) {
  var _action$payload2 = action.payload,
      formPrefills = _action$payload2.bookInfo.formPrefills,
      configuredCustomFormFields = _action$payload2.customFormFields;

  var _state$originalFormSt = state.originalFormState.toObject(),
      firstName = _state$originalFormSt.firstName,
      lastName = _state$originalFormSt.lastName,
      customFormFields = _state$originalFormSt.customFormFields;

  return state.email !== formPrefills.email ? _FormState.default.from({
    firstName: firstName,
    lastName: lastName,
    email: state.email,
    customFormFields: configuredCustomFormFields.merge(customFormFields)
  }) : state;
}), (0, _defineProperty2.default)(_handleActions, ActionTypes.SET_FORM_FIELD, function (state, action) {
  var _action$payload3 = action.payload,
      fieldName = _action$payload3.fieldName,
      fieldValue = _action$payload3.fieldValue;

  if (state.has(fieldName)) {
    return state.set(fieldName, fieldValue);
  } else if (state.hasIn(['customFormFields', fieldName])) {
    return state.setIn(['customFormFields', fieldName], fieldValue);
  }

  return state;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;